import { render, staticRenderFns } from "./HolidaysForm.vue?vue&type=template&id=da38348a&scoped=true"
import script from "./HolidaysForm.vue?vue&type=script&lang=js"
export * from "./HolidaysForm.vue?vue&type=script&lang=js"
import style0 from "./HolidaysForm.vue?vue&type=style&index=0&id=da38348a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da38348a",
  null
  
)

export default component.exports